<template>
    <div class="modal fade show add-note-modal" aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered modal-lg" ref="admissionModalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center px-1 my-1 align-item-center">
                            <h1 class="mb-0">Add Dentition</h1>
                            <button @click="closeModal" type="button" class="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0">
                
                <div class="modal-body">


                    <div v-if="dentition.notation_type === 'universal' && dentitionType === 'primary'" class="col-8 parent-primary-partition">
                        <div>
                            <h4>Primary Dentition</h4>
                        </div>
                        <div class="row primary-partition-row">
                            <div v-for="(item, key) in dentitionTeethNumbers" :key="key" class="col-12 d-flex primary-partition-col justify-content-between">
                                <button
                                    v-for="i in item" :key="i"
                                    class="btn cancel-subscription waves-effect num-btn btn-sm"
                                    :class="selectedDentition.includes(i) ? 'btn-primary' : 'btn-outline-primary'"
                                    @click="onSelectDentition(i, 'primary')"
                                >{{ i }}</button>
                            </div>
                        </div>
                    </div>
                    
                    <div v-else :class="`col-${dentitionType === 'primary' ? '10': '12'} parent-permanent-partition`">
                        <div>
                            <h4>{{ dentitionType === 'primary' ? 'Primary' : 'Permanent' }} Dentition</h4>
                        </div>
                        <div class="row permanent-partition-row">
                            <div v-for="(item, key) in dentitionTeethNumbers" :key="key" class="col-6 row permanent-partition-col d-flex justify-content-between">
                                <div class="col-12">
                                    {{ permanentDentitionPosition[key] || key }}
                                </div>
                                <div class="col-12 d-flex justify-content-between">
                                    <button
                                        v-for="i in item" :key="i"
                                        class="btn cancel-subscription waves-effect num-btn btn-sm"
                                        :class="selectedDentition.includes(i) ? 'btn-primary' : 'btn-outline-primary'"
                                        @click="onSelectDentition(i, 'permanent')"
                                    >{{ getDentitionNumber(i) }}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 text-center">
                        <SubmitCancelBtn
                            @onSubmit="submit"
                            @onCancel="closeModal"
                        />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import SubmitCancelBtn from '@/components/atom/SubmitCancelBtn.vue';
import { onMounted, ref, watch } from 'vue';
import { computed } from 'vue';

const props = defineProps({
    dentition: {
        type: Object || null,
        default: () => {}
    },
    dentitionType: {
        type: String || null,
        default: null,
    },
    dentitionItem: {
        type: Object || null,
        default: () => {}
    },
    isOpenModal: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:isOpenModal']);

const dentitionTeethNumbers = computed(() => {

    if (! props.dentition) return [];

    const prefix = props.dentition.notation_type === 'fdi' ? 'fdi_' : '';

    if (props.dentitionType === 'permanent') {
        return props.dentition && props.dentition[prefix + 'permanent_dentition'];
    }

    return props.dentition && props.dentition[prefix + 'primary_dentition'];
});

const selectedDentition = ref([]);
const permanentDentitionPosition = {
    top_start: 'Upper Right',
    top_end: 'Upper Left',
    bottom_start: 'Lower Right',
    bottom_end: 'Lower Left',
};

const closeModal = () => {
    emit('update:isOpenModal', false);
}

const onSelectDentition = (i, type) => {

    const index = selectedDentition.value.indexOf(i);

    if(index < 0) {
        selectedDentition.value.push(i);
        return;
    }
    
    selectedDentition.value.splice(index, 1)
}

const submit = () => {
    emit('onSaveDentition', selectedDentition.value);
    closeModal();
}

const getDentitionNumber = (i) => {
    let match = i.match(/-(.*)/);
    let position = match ? match[1] : i;

    if(props.dentition.notation_type === 'fdi' && props.dentitionType === 'primary') {
        return position.toUpperCase();
    }
    
    return position.padStart(2, '0').toUpperCase();
}

onMounted(() => {
    if(props.dentitionItem && props.dentitionItem.dentition && props.dentitionItem.dentition.length > 0) {
        selectedDentition.value = props.dentitionItem.dentition;
    }
})

</script>


<style scoped>
.modal-body{
    min-height: 400px;
}
.bg {
    background: aliceblue !important;
}
.modal-card{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-height: 280px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.add-note-modal {
    display: block; 
    background: #1c1d1c33
}

.permanent-partition-row {
    display: flex;
    border-radius: 5px;
    border: 1px solid gray;
    padding: 10px 11px 5px 0px;
    margin: 2px;
    justify-content: space-between;
}
.primary-partition-row {
    border-radius: 5px;
    border: 1px solid gray;
    padding: 10px 0px 5px 0px;
    margin-left: -3px;
    margin-right: 0px;
}
.num-btn {
    padding-left: .8rem;
    padding-right: .8rem;
}
.permanent-partition-col {
    padding-right: 0;
    margin-bottom: 8px;
}
.primary-partition-col {
    margin-bottom: 8px;
}
</style>